/**
 *   This is a service for a specific store module.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */
import Store from '@/store/store';

export default {
  /**
   * Subscribe for push notifications.
   */
  async errorHandler(message: string) {
    Store.dispatch('app/snackbar', {
      show: true,
      text: message,
      color: 'error',
      icon: Store.getters['app/icons'].error,
    });
  },

  async successHandler(message: string) {
    Store.dispatch('app/snackbar', {
      show: true,
      text: message,
      color: 'success',
      icon: Store.getters['app/icons'].success,
    });
  },

  async getDrawer() {
    return Store.getters['app/drawer'];
  },

  async setDrawer(val: any) {
    Store.dispatch('app/SET_DRAWER', val);
  },
};
